import { Button } from "@/components/ui/button";
import { TranscriptionView, transcriptionViewOptions } from "@/lib/api/customer";
import { cn } from "@/lib/utils";

interface TranscriptionViewFilterButtonsProps {
  value: TranscriptionView;
  onValueChange: (value: TranscriptionView) => void;
  className?: string;
}

/** Needs review / Visible / Removed, styled like `TodoSourceFilterButtons`. */
export function TranscriptionViewFilterButtons({ value, onValueChange, className }: TranscriptionViewFilterButtonsProps) {
  return (
    <div
      role="group"
      aria-label="Filter Todos by review state"
      className={cn("inline-flex items-center rounded-md border border-input overflow-hidden", className)}
    >
      {transcriptionViewOptions.map((option: { value: TranscriptionView; label: string }, index: number) => (
        <Button
          key={option.value}
          type="button"
          size="sm"
          variant={value === option.value ? "default" : "ghost"}
          aria-pressed={value === option.value}
          data-testid={`transcription-view-${option.value}`}
          data-selected={value === option.value}
          onClick={() => onValueChange(option.value)}
          className={cn(
            "rounded-none focus-visible:ring-offset-0",
            index > 0 && "border-l border-input",
          )}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
